import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
declare let $: any;

@Injectable()
export class BrandService {
  responseData: any;
  handleError: any;
  private siteurl: string = '/get-brand/';
  constructor(private httpClient: HttpClient) {
    this.httpClient = httpClient;
  }
  getBrand(brandName) {
    return this.httpClient.get(this.siteurl + brandName);
  }
}